import AsoHeader from '../../../components/Aso/Header';
import AsoValidarSmsInfo from '../../../components/Aso/Register/AsoValidaSmsToken';

const AsoRegistroValidarSmsToken: React.FC = () => {

    return (
        <div>
            <AsoHeader />
            <AsoValidarSmsInfo />
        </div>
    );
}

export default AsoRegistroValidarSmsToken